import {
  aliasesFormatting,
  basicFormatting,
  getCountryCode,
  iocFormatting,
  listCountryCodeFormatting,
  motivationsFormatting,
} from '../../hooks/dataFormatting'

export function normalizeActor(data) {
  if (!data) { return data }

  const decorated = { ...data }

  decorated.aliases = aliasesFormatting(data.aliases)
  decorated.associatedMalware = basicFormatting(data.malware)
  decorated.countryCode = getCountryCode(data.locations?.source)
  decorated.cve = data.cve || []
  decorated.motivations = motivationsFormatting(data.motivations || data.motivation)
  decorated.ioc = iocFormatting(data.ioc)
  decorated.targetedIndustries = basicFormatting(data.identities)
  decorated.targetedLocations = listCountryCodeFormatting(data.locations?.target)
  decorated.sourceLocations = listCountryCodeFormatting(data.locations?.source)

  return decorated
}
